import { routes } from "@/global/routes";
import {
  LuxurySuitesContent,
  PartySuitesContent,
  TheClubSuitesContent,
  inventoryCardSuiteModal,
  NewYorkYankeesInventoryCard,
  NewYorkYankeesInventoryCardViewMenu,
} from "../newyorkyankees_suites/helpers";
import {
  faqs,
  howItWorks,
  AnalyticsHeader,
  NewYorkYankeesTCListItems,
  NewYorkYankeesCheckoutTerms,
  AdditionalCheckoutInputFields,
  NewYorkYankeesAdditionalDetailsDisclaimerTC,
} from "./helpers";
import { inventoryTypeUIDs, vendorUUIDs } from "../../constants";
import { DefaultRegistrationTerms } from "../../default_terms_and_conditions";

import LogoImage from "public/images/newyorkyankees/yankees.png";
import SeatMap3DImage from "public/images/newyorkyankees/seatmap.png";
import Banner from "public/images/newyorkyankees/NYY_25_PS_SuitesBanner.jpg";
import BackgroundImage from "public/images/newyorkyankees/yankees-background.jpg";
import staticSeatMapImage from "public/images/newyorkyankees/NYY_25_SuiteMaps_Graphic_1498x840.jpg";

import type { TeamConfig } from "../types";

import luxurySuite30to46Image1 from "public/images/newyorkyankees/Luxury Suites 30-46/1IMG_3569.jpg";
import luxurySuite30to46Image2 from "public/images/newyorkyankees/Luxury Suites 30-46/2IMG_3570.jpg";
import luxurySuite30to46Image3 from "public/images/newyorkyankees/Luxury Suites 30-46/3IMG_3571.jpg";
import luxurySuite30to46Image4 from "public/images/newyorkyankees/Luxury Suites 30-46/4IMG_3572.jpg";
import luxurySuite30to46Image5 from "public/images/newyorkyankees/Luxury Suites 30-46/5IMG_3573.jpg";

import suiteImage8 from "public/images/newyorkyankees/20230525_SUITES_015.jpg";
import suiteImage9 from "public/images/newyorkyankees/20230525_SUITES_010.jpg";
import suiteImage10 from "public/images/newyorkyankees/20230525_SUITES_018.jpg";
import suiteImage11 from "public/images/newyorkyankees/20230525_SUITES_019.jpg";

import clubSuiteImage1 from "public/images/newyorkyankees/Club Suite 62/1Photo-Apr-25-2025,-2-25-43-PM.jpg";
import clubSuiteImage2 from "public/images/newyorkyankees/Club Suite 62/2Photo Apr 25 2025, 2 27 12 PM.jpg";
import clubSuiteImage3 from "public/images/newyorkyankees/Club Suite 62/3Photo-Apr-25-2025,-2-25-21-PM.jpg";
import clubSuiteImage4 from "public/images/newyorkyankees/Club Suite 62/4Photo-Apr-25-2025,-2-26-39-PM.jpg";
import clubSuiteImage5 from "public/images/newyorkyankees/Club Suite 62/5Photo-Apr-25-2025,-2-35-58-PM.jpg";

import luxurySuite11Image1 from "public/images/newyorkyankees/Luxury Suite 11/1Photo-Apr-25-2025,-2-40-56-PM.jpg";
import luxurySuite11Image2 from "public/images/newyorkyankees/Luxury Suite 11/2Photo-Apr-25-2025,-2-39-00-PM.jpg";
import luxurySuite11Image3 from "public/images/newyorkyankees/Luxury Suite 11/3Photo Apr 25 2025, 2 39 46 PM.jpg";

import luxurySuite67Image1 from "public/images/newyorkyankees/Luxury Suite 67/1Photo Apr 25 2025, 2 21 23 PM.jpg";
import luxurySuite67Image2 from "public/images/newyorkyankees/Luxury Suite 67/2Photo Apr 25 2025, 2 22 35 PM.jpg";
import luxurySuite67Image3 from "public/images/newyorkyankees/Luxury Suite 67/3Photo Apr 25 2025, 2 22 44 PM.jpg";
import luxurySuite67Image4 from "public/images/newyorkyankees/Luxury Suite 67/4Photo Apr 25 2025, 2 24 06 PM.jpg";

import luxurySuite8to10Image1 from "public/images/newyorkyankees/Luxury Suites 8-10/1Photo Apr 25 2025, 2 41 35 PM.jpg";
import luxurySuite8to10Image2 from "public/images/newyorkyankees/Luxury Suites 8-10/2Photo Apr 25 2025, 2 41 16 PM.jpg";
import luxurySuite8to10Image3 from "public/images/newyorkyankees/Luxury Suites 8-10/3Photo Apr 25 2025, 2 41 52 PM.jpg";
import luxurySuite8to10Image4 from "public/images/newyorkyankees/Luxury Suites 8-10/4Photo Apr 25 2025, 2 42 04 PM.jpg";
import luxurySuite8to10Image5 from "public/images/newyorkyankees/Luxury Suites 8-10/5Photo Apr 25 2025, 2 42 37 PM.jpg";

import luxurySuiteImage1 from "public/images/newyorkyankees/Luxury Suites 12-29 + 47-61/1Photo Apr 25 2025, 2 36 31 PM.jpg";
import luxurySuiteImage2 from "public/images/newyorkyankees/Luxury Suites 12-29 + 47-61/2Photo Apr 25 2025, 2 36 46 PM.jpg";
import luxurySuiteImage3 from "public/images/newyorkyankees/Luxury Suites 12-29 + 47-61/3Photo Apr 25 2025, 2 37 09 PM.jpg";

import partySuite1Image1 from "public/images/newyorkyankees/Party Suite 1/1Photo Apr 25 2025, 2 49 24 PM.jpg";
import partySuite1Image2 from "public/images/newyorkyankees/Party Suite 1/2Photo Apr 25 2025, 2 50 03 PM.jpg";
import partySuite1Image3 from "public/images/newyorkyankees/Party Suite 1/3Photo Apr 25 2025, 2 50 37 PM.jpg";
import partySuite1Image4 from "public/images/newyorkyankees/Party Suite 1/4Photo Apr 25 2025, 2 51 29 PM.jpg";
import partySuite1Image5 from "public/images/newyorkyankees/Party Suite 1/5Photo Apr 25 2025, 2 52 48 PM.jpg";

import partySuite2to7Image1 from "public/images/newyorkyankees/Party Suites 2-7/1Photo Apr 25 2025, 2 45 38 PM.jpg";
import partySuite2to7Image2 from "public/images/newyorkyankees/Party Suites 2-7/2Photo Apr 25 2025, 2 46 13 PM.jpg";
import partySuite2to7Image3 from "public/images/newyorkyankees/Party Suites 2-7/3Photo Apr 25 2025, 2 47 32 PM.jpg";
import partySuite2to7Image4 from "public/images/newyorkyankees/Party Suites 2-7/4Photo Apr 25 2025, 2 48 28 PM.jpg";

import standardMenuImage from "public/images/newyorkyankees/IGS Standard Menu V4 for Attend V2.jpg";

////////////////////////////////////////////////////////////////////////

const thirdBlock = [
  standardMenuImage.src,
  suiteImage8.src,
  suiteImage9.src,
  suiteImage10.src,
  suiteImage11.src,

  "https://ss-leagues.s3.amazonaws.com/MLB/NY%20Yankees%20Suites%20Assets/20230525_SUITES_025.JPG",
  "https://ss-leagues.s3.amazonaws.com/MLB/NY%20Yankees%20Suites%20Assets/20230525_SUITES_014.JPG",
  "https://ss-leagues.s3.amazonaws.com/MLB/NY%20Yankees%20Suites%20Assets/Still%202024-11-20%20152413_1.8.1.jpg",
];

const fourthBlock = [
  standardMenuImage.src,
  // "yankees.io-media.com/#/vr/Suite/32/Interior/1/d",
  luxurySuite30to46Image1.src,
  luxurySuite30to46Image2.src,
  luxurySuite30to46Image3.src,
  luxurySuite30to46Image4.src,
  luxurySuite30to46Image5.src,

  "https://ss-leagues.s3.amazonaws.com/MLB/NY%20Yankees%20Suites%20Assets/20230525_SUITES_025.JPG",
  "https://ss-leagues.s3.amazonaws.com/MLB/NY%20Yankees%20Suites%20Assets/20230525_SUITES_014.JPG",
  "https://ss-leagues.s3.amazonaws.com/MLB/NY%20Yankees%20Suites%20Assets/Still%202024-11-20%20152413_1.8.1.jpg",
];

const clubSuite62 = [
  standardMenuImage.src,
  clubSuiteImage1.src,
  clubSuiteImage2.src,
  clubSuiteImage3.src,
  clubSuiteImage4.src,
  clubSuiteImage5.src,

  "https://ss-leagues.s3.amazonaws.com/MLB/NY%20Yankees%20Suites%20Assets/20230525_SUITES_025.JPG",
  "https://ss-leagues.s3.amazonaws.com/MLB/NY%20Yankees%20Suites%20Assets/20230525_SUITES_014.JPG",
  "https://ss-leagues.s3.amazonaws.com/MLB/NY%20Yankees%20Suites%20Assets/Still%202024-11-20%20152413_1.8.1.jpg",
];

const luxurySuite11 = [
  standardMenuImage.src,
  luxurySuite11Image1.src,
  luxurySuite11Image2.src,
  luxurySuite11Image3.src,

  "https://ss-leagues.s3.amazonaws.com/MLB/NY%20Yankees%20Suites%20Assets/20230525_SUITES_025.JPG",
  "https://ss-leagues.s3.amazonaws.com/MLB/NY%20Yankees%20Suites%20Assets/20230525_SUITES_014.JPG",
  "https://ss-leagues.s3.amazonaws.com/MLB/NY%20Yankees%20Suites%20Assets/Still%202024-11-20%20152413_1.8.1.jpg",
];

const luxurySuite67 = [
  standardMenuImage.src,
  luxurySuite67Image1.src,
  luxurySuite67Image2.src,
  luxurySuite67Image3.src,
  luxurySuite67Image4.src,

  "https://ss-leagues.s3.amazonaws.com/MLB/NY%20Yankees%20Suites%20Assets/20230525_SUITES_025.JPG",
  "https://ss-leagues.s3.amazonaws.com/MLB/NY%20Yankees%20Suites%20Assets/20230525_SUITES_014.JPG",
  "https://ss-leagues.s3.amazonaws.com/MLB/NY%20Yankees%20Suites%20Assets/Still%202024-11-20%20152413_1.8.1.jpg",
];

const luxurySuite8to10 = [
  standardMenuImage.src,
  luxurySuite8to10Image1.src,
  luxurySuite8to10Image2.src,
  luxurySuite8to10Image3.src,
  luxurySuite8to10Image4.src,
  luxurySuite8to10Image5.src,

  "https://ss-leagues.s3.amazonaws.com/MLB/NY%20Yankees%20Suites%20Assets/20230525_SUITES_025.JPG",
  "https://ss-leagues.s3.amazonaws.com/MLB/NY%20Yankees%20Suites%20Assets/20230525_SUITES_014.JPG",
  "https://ss-leagues.s3.amazonaws.com/MLB/NY%20Yankees%20Suites%20Assets/Still%202024-11-20%20152413_1.8.1.jpg",
];

const luxurySuites = [
  standardMenuImage.src,
  luxurySuiteImage1.src,
  luxurySuiteImage2.src,
  luxurySuiteImage3.src,

  "https://ss-leagues.s3.amazonaws.com/MLB/NY%20Yankees%20Suites%20Assets/20230525_SUITES_025.JPG",
  "https://ss-leagues.s3.amazonaws.com/MLB/NY%20Yankees%20Suites%20Assets/20230525_SUITES_014.JPG",
  "https://ss-leagues.s3.amazonaws.com/MLB/NY%20Yankees%20Suites%20Assets/Still%202024-11-20%20152413_1.8.1.jpg",
];

const partySuite1 = [
  standardMenuImage.src,
  // "yankees.io-media.com/#/vr/Suite/PartySuite/Interior/1/d",
  partySuite1Image1.src,
  partySuite1Image2.src,
  partySuite1Image3.src,
  partySuite1Image4.src,
  partySuite1Image5.src,

  "https://ss-leagues.s3.amazonaws.com/MLB/NY%20Yankees%20Suites%20Assets/20230525_SUITES_025.JPG",
  "https://ss-leagues.s3.amazonaws.com/MLB/NY%20Yankees%20Suites%20Assets/20230525_SUITES_014.JPG",
  "https://ss-leagues.s3.amazonaws.com/MLB/NY%20Yankees%20Suites%20Assets/Still%202024-11-20%20152413_1.8.1.jpg",
];

const partySuite2to7 = [
  standardMenuImage.src,
  // "yankees.io-media.com/#/vr/Suite/PartySuite/Interior/1/d",
  partySuite2to7Image1.src,
  partySuite2to7Image2.src,
  partySuite2to7Image3.src,
  partySuite2to7Image4.src,

  "https://ss-leagues.s3.amazonaws.com/MLB/NY%20Yankees%20Suites%20Assets/20230525_SUITES_025.JPG",
  "https://ss-leagues.s3.amazonaws.com/MLB/NY%20Yankees%20Suites%20Assets/20230525_SUITES_014.JPG",
  "https://ss-leagues.s3.amazonaws.com/MLB/NY%20Yankees%20Suites%20Assets/Still%202024-11-20%20152413_1.8.1.jpg",
];

////////////////////////////////////////////////////////////////////////

const config: TeamConfig = {
  teamSchema: "newyorkyankees_suites_postseason",
  browserTitle: "NY Yankees Postseason Suites",
  packages: false,
  defaultRoute: routes.purchaseSeats,
  phoneNumber: "",
  mlbTeamId: 147,
  teamName: "New York Yankees",

  packs: {
    enabled: true,
    dontOpenPackModal: true,
    disablePackSelectionLossModal: true,
    independentPacks: true,
    list: [
      {
        id: 2,
        amount: 4,
        title: "Championship Series Home Games",
        description:
          "Purchase a suite for a Championship Series home game. Three 2027 regular season games must be purchased with order. Postseason games not played will be refunded.",
        offerMoreMessage: "",
        defaultSelected: true,
        buckets: [
          {
            id: 1,
            title: "Championship Series Home Games",
            description: "Select 1 Game",
            max: 1,
            min: 1,
          },
          {
            id: 2,
            title: "2027 Regular Season",
            description: "Select 3 Non-Refundable Games",
            max: 3,
            min: 3,
          },
        ],
        updatedAccountGroup: 0,
        successMessage:
          "You're good to go! Add more games or select Continue to view seating options.",
      },
      {
        id: 3,
        amount: 8,
        title: "World Series",
        description:
          "Purchase a suite for a World Series home game. Six 2027 regular season games must be purchased with order. Postseason games not played will be refunded.",
        offerMoreMessage: "",
        buckets: [
          {
            id: 1,
            title: "World Series Home Games",
            description: "Select 1 Game",
            max: 1,
            min: 1,
          },
          {
            id: 2,
            title: "Championship Series Home Games",
            description: "Select 1 Game",
            max: 1,
            min: 1,
          },
          {
            id: 3,
            title: "2027 Regular Season",
            description: "Select 6 Non-Refundable Games",
            max: 6,
            min: 6,
          },
        ],
        updatedAccountGroup: 0,
        successMessage:
          "You're good to go! Add more games or select Continue to view seating options.",
      },
    ],
  },

  // seat map configs
  seatMapConfigs: {
    venueId: "nam-us-10171-yankees-sec",
    mapId: "blockmap2d",
    isIoMedia3dViewEnabled: false,
    staticSeatMapImage: staticSeatMapImage.src,
    customSeatMapStaticImageStyle: {
      display: "block",
      width: "100%",
      marginX: "auto",
    },

    suiteImages: {
      PS1: partySuite1,

      PS2: partySuite2to7,
      PS3: partySuite2to7,
      PS4: partySuite2to7,
      PS5: partySuite2to7,
      PS6: partySuite2to7,
      PS7: partySuite2to7,

      LS8: luxurySuite8to10,
      LS9: luxurySuite8to10,
      LS10: luxurySuite8to10,

      LS11: luxurySuite11,

      LS12: luxurySuites,
      LS13: luxurySuites,
      LS14: luxurySuites,
      LS15: luxurySuites,
      LS16: luxurySuites,
      LS17: luxurySuites,
      LS18: luxurySuites,
      LS19: luxurySuites,
      LS20: luxurySuites,
      LS21: luxurySuites,
      LS22: luxurySuites,
      LS23: luxurySuites,
      LS24: luxurySuites,
      LS25: luxurySuites,
      LS26: luxurySuites,
      LS27: luxurySuites,
      LS28: luxurySuites,
      LS29: luxurySuites,

      LS30: fourthBlock,
      LS31: fourthBlock,
      LS32: fourthBlock,
      LS33: fourthBlock,
      LS34: fourthBlock,
      LS35: fourthBlock,
      LS36: fourthBlock,
      LS37: fourthBlock,
      LS38: fourthBlock,
      LS39: fourthBlock,
      LS40: fourthBlock,
      LS41: fourthBlock,
      LS42: fourthBlock,
      LS43: fourthBlock,
      LS44: fourthBlock,
      LS45: fourthBlock,
      LS46: fourthBlock,

      LS47: luxurySuites,
      LS48: luxurySuites,
      LS49: luxurySuites,
      LS50: luxurySuites,
      LS51: luxurySuites,
      LS52: luxurySuites,
      LS53: luxurySuites,
      LS54: luxurySuites,
      LS55: luxurySuites,
      LS56: luxurySuites,
      LS57: luxurySuites,
      LS58: luxurySuites,
      LS59: luxurySuites,
      "60": luxurySuites,
      "61": luxurySuites,

      "62": clubSuite62,
      "66": thirdBlock,

      "67": luxurySuite67,
    },
  },

  // gift cards
  giftCardConfigs: {
    isMenuGiftCardEnabled: false,
    isLandingPageGiftCardEnabled: false,
    isStandalonePageGiftCardEnabled: false,
    redirectGiftCardUrl: routes.redeem,
  },

  // purchase credit configs
  purchaseCreditConfigs: {
    isLandingPurchaseCreditEnabled: false,
    isStandAlonePurchaseCreditEnabled: false,
    showPurchaseCreditLinkInHomeMenu: false,
    isPurchaseCreditHistoryEnabled: false,
  },

  // disabled routes
  disabledRoutes: [],

  // switches
  checkoutCreditPackages: false,
  availableCreditEnabled: false,
  isCrowdHandlerEnabled: true,
  inventoryType: inventoryTypeUIDs.suiteLevelV2,

  // purchase seats config
  purchaseSeatConfigs: {
    minGameSelectionCount: 1,
    minSeatLimit: 1,
    isSimilarSeatForAllEvents: false,
    allowManualCartInSimilar: false,
    isCheckoutEditSeatsEnabled: false,
    isDiffSeatAlertEnabled: false,
    hideViewTicketsInThankYouPage: true,

    isCheckoutAdditionalDetailsEnabled: true,
    isPerksEnabled: true,
  },

  // feature configs
  packageConfigs: {
    isPackageEnabled: false,
    canRemovePackageGames: false,
    staticBuildYourOwn: null,
  },

  // intercom settings
  intercomConfigs: {
    isIntercomEnabled: false,
    allowedPages: [],
  },

  // checkout validations
  checkoutValidation: {
    allowedZipFailCount: Infinity,
    allowedPaymentFailCount: Infinity,
  },

  // analytics configs
  analyticsConfigs: {
    googleAnalyticsId: "",
    attrkPixelId: "",
    beaconId: "",
    googleTagManagerId: "",
    AnalyticsHeader: AnalyticsHeader,
  },

  // redirect configs
  redirectConfigs: {
    internalRedirectUrl: "",
    externalRedirectUrl: "",
  },

  refreshInventoryWhenEventClick: false,

  isSaveCardAllowed: false,

  // urls
  accountManagerUrl: "https://am.ticketmaster.com/nyyreg/",

  // vendor
  platform: vendorUUIDs.ticketmaster,

  // okta config
  oktaIssuer: "",
  oktaClientId: "",
  shouldUseInternalLogin: false,

  isBrainTreePaymentEnabled: false,

  // images
  images: {
    logoNameImage: "",
    seatMap3dPreviewImage: SeatMap3DImage.src,
    faviconImage: LogoImage.src,
    giftCardStandalonePageImage: "",
    findGamesBannerImage: Banner.src,
    authBackgroundImage: BackgroundImage.src,
    checkoutStatusPageImage: BackgroundImage.src,
    logoImage: LogoImage.src + "?width=128&height=66",
  },

  uiConfigs: {
    bannerImage: {
      title: "",
      isBackgroundBasedBanner: false,
    },

    featuredGameCard: {
      showLogoWithTitle: false,
      hideOverlayLogo: false,
    },
    bottomBar: {
      showGameSelectionProgress: true,
    },

    hidePackageBalanceOnCheckout: true,
    hideServiceFee: true,

    checkoutPage: {
      checkoutForm: {
        sameAsContractSignerDefaultChecked: true,
        additionalInputFields: <AdditionalCheckoutInputFields />,
      },
    },

    inventoryCardSettings: {
      isPBLineItemsVisible: true,
      seatCountLabel: "Tickets Included",
      inventorySuitePackageInfo: "Included",
      pbLineItemsValue: 5,
      customOverflowLabel: "Additional Tickets",

      suiteLevelInventoryCard: {
        customButtons: [
          {
            id: 1,
            label: "More Info",
            onClick: () => {
              inventoryCardSuiteModal.getState().set({
                isOpen: true,
                title: "More Info",
                content: <TheClubSuitesContent />,
              });
            },
            suiteNames: ["Suite 62"],
          },
          {
            id: 2,
            label: "More Info",
            onClick: () => {
              inventoryCardSuiteModal.getState().set({
                isOpen: true,
                title: "More Info",
                content: <LuxurySuitesContent />,
              });
            },
            suiteNames: [
              ...Array.from({ length: 61 }, (_, i) => {
                // different from suite 62
                if (i + 8 != 62) return `Suite ${i + 8}`;
                return "";
              }),
              "Suite 67",
            ],
          },
          {
            id: 3,
            label: "More Info",
            onClick: () => {
              inventoryCardSuiteModal.getState().set({
                isOpen: true,
                title: "More Info",
                content: <PartySuitesContent />,
              });
            },
            suiteNames: Array.from({ length: 7 }, (_, i) => `Suite ${i + 1}`),
          },
          // {
          //   id: 4,
          //   label: "View Menu",
          //   onClick: () => {
          //     inventoryCardSuitViewMenueModal.getState().set({ isOpen: true });
          //   },
          //   suiteNames: Array.from({ length: 67 }, (_, i) => `Suite ${i + 1}`),
          // },
        ],
        renderBody: [
          {
            id: 1,
            component: () => <NewYorkYankeesInventoryCard />,
          },
          {
            id: 2,
            component: () => <NewYorkYankeesInventoryCardViewMenu />,
          },
        ],
      },
    },
    inventoryContainer: {
      getGridCellHeight: (arg) => (arg?.mdDown ? 280 : 180),
    },

    findGames: {
      showOneEventPerRow: true,
    },

    eventCardSettings: {
      soldOutTagLabel: "Sold Out",
      soldOutTagColor: "#6a6a6a",
    },

    gameFiltersSettings: {
      hideSectionFilter: false,
      hideAccessibilityFilter: false,
      disableSeatCounterAfterFirstEventHeld: true,
      hideGameFiltersOnFindGames: true,
    },
  },

  colors: {
    primary: "#132448",
  },

  howItWorks: howItWorks,
  faqs: faqs,

  languages: {
    topNavMenuItems: <NewYorkYankeesTCListItems />,
    checkoutTermsAndCondition: <NewYorkYankeesCheckoutTerms />,
    registrationTermsAndCondition: <DefaultRegistrationTerms />,
    additionalDetailsDisclaimerTC: (
      <NewYorkYankeesAdditionalDetailsDisclaimerTC />
    ),
    purchaseSeats: {
      suiteLanguageDisclaimer:
        "Please note that individual suites may vary from the photos displayed.",
      progressBarSuccessText:
        "You're good to go! Add more events or select Continue to view seating options.",
      chooseSeatsTabTitle: "Choose Suite",
      progressBarAditionalText: " to continue!",
      progressBarPackText: "bundle",
    },

    purchaseGiftCard: null,
    redeemGiftCard: null,

    checkoutSuccessMessage: "Your purchase is complete!",
    checkoutSuccessDescription:
      "Your New York Yankees tickets are confirmed! Tickets will be in your account within the next 24 hours.",

    giftCard: {
      title: "",
      createGiftCard: {
        description: "",
        recipient: {
          sendNowFalse: {
            description: "",
          },
          sendNowTrue: {
            description: "",
          },
        },
      },
      redeemGiftCard: {
        loggedIn: {
          description: "",
        },
        logout: {
          description: "",
        },
        success: {
          description: "",
        },
      },
    },

    signInAuthText:
      "Connect your ticketmaster account to continue with seamless access.",
  },
};

export default config;
